/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityRead } from '../models/EntityRead';
import type { EntityWriteSerializerWithRepr } from '../models/EntityWriteSerializerWithRepr';
import type { PaginatedEntityListList } from '../models/PaginatedEntityListList';
import type { PaginatedEntityWriteSerializerWithReprList } from '../models/PaginatedEntityWriteSerializerWithReprList';
import type { PatchedEntityWriteSerializerWithRepr } from '../models/PatchedEntityWriteSerializerWithRepr';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EntitiesService {
    /**
     * @returns PaginatedEntityListList
     * @throws ApiError
     */
    public static entitiesList({
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
        types,
    }: {
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        types?: Array<string>,
    }): CancelablePromise<PaginatedEntityListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/entities/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'types': types,
            },
        });
    }
    /**
     * @returns EntityWriteSerializerWithRepr
     * @throws ApiError
     */
    public static entitiesCreate({
        requestBody,
    }: {
        requestBody: EntityWriteSerializerWithRepr,
    }): CancelablePromise<EntityWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/entities/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedEntityWriteSerializerWithReprList
     * @throws ApiError
     */
    public static entityBulkUpdate({
        requestBody,
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
        types,
    }: {
        requestBody: Array<EntityWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        types?: Array<string>,
    }): CancelablePromise<PaginatedEntityWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/entities/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'types': types,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedEntityWriteSerializerWithReprList
     * @throws ApiError
     */
    public static entityBulkPartialUpdate({
        requestBody,
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
        types,
    }: {
        requestBody: Array<EntityWriteSerializerWithRepr>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
        types?: Array<string>,
    }): CancelablePromise<PaginatedEntityWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/entities/',
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
                'types': types,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static entityBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/entities/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns EntityRead
     * @throws ApiError
     */
    public static entitiesRetrieve({
        id,
        excludeFields,
        fields,
        name,
        readDepth,
        types,
    }: {
        /**
         * A unique integer value identifying this entity.
         */
        id: number,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        name?: Array<string>,
        readDepth?: number,
        types?: Array<string>,
    }): CancelablePromise<EntityRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/entities/{id}/',
            path: {
                'id': id,
            },
            query: {
                'exclude-fields': excludeFields,
                'fields': fields,
                'name': name,
                'read_depth': readDepth,
                'types': types,
            },
        });
    }
    /**
     * @returns EntityWriteSerializerWithRepr
     * @throws ApiError
     */
    public static entitiesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this entity.
         */
        id: number,
        requestBody: EntityWriteSerializerWithRepr,
    }): CancelablePromise<EntityWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/entities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns EntityWriteSerializerWithRepr
     * @throws ApiError
     */
    public static entitiesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this entity.
         */
        id: number,
        requestBody?: PatchedEntityWriteSerializerWithRepr,
    }): CancelablePromise<EntityWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/entities/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static entitiesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this entity.
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/entities/{id}/',
            path: {
                'id': id,
            },
        });
    }
}
